var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('pro-carousel',{staticClass:"internal-section-component",attrs:{"area":_vm.area,"buh-context":_vm.stockType,"items-prop":_vm.items}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }